import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { reduxForm, reset } from 'redux-form';
import { notification } from 'antd';
import { fromEntities } from '../../store/selectors';
import AlcoholTab from '../../components/molecules/AlcoholTab/index';
import { resourceUpdateRequest, resourceDetailReadRequest } from '../../store/resource/actions';

class AlcoholTabContainer extends Component {
  componentDidMount() {
    this.props.getAlcohol().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not alcohol data.',
        duration: 0,
      })
    );
  }

  render() {
    return <AlcoholTab {...this.props} />;
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  initialValues: {
    ...fromEntities.getDetail(state, 'advertiserAdAlcohol', lineItemId),
  },
});

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  getAlcohol: () =>
    dispatch(resourceDetailReadRequest('advertiser-ad/:id/alcohol', { id: lineItemId })),
  addAlcohols: alcoholIds =>
    dispatch(resourceUpdateRequest('advertiser-ad/:id/alcohol', { id: lineItemId }, alcoholIds)),
});

const onSubmit = (values, dispatch, props) => {
  console.log(values);

  return props
    .addAlcohols(values)
    .then(() => {
      dispatch(reset('AlcoholTab'));
      return notification.success({
        message: 'Success',
        description: 'Alcohol updated.',
        duration: 4,
      });
    })
    .catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not update alcohol.',
        duration: 0,
      })
    );
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    enableReinitialize: true,
    form: 'AlcoholTab',
    onSubmit,
  })
)(AlcoholTabContainer);
